import { render, staticRenderFns } from "./marketActivity.vue?vue&type=template&id=65678e98&scoped=true"
import script from "./marketActivity.vue?vue&type=script&lang=js"
export * from "./marketActivity.vue?vue&type=script&lang=js"
import style0 from "./marketActivity.vue?vue&type=style&index=0&id=65678e98&prod&lang=scss"
import style1 from "./marketActivity.vue?vue&type=style&index=1&id=65678e98&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65678e98",
  null
  
)

export default component.exports